import React from "react";
import FAQsPricing from "../components/FAQsPricing";
import HeaderCities from "../components/HeaderCities";
import "../assets/css/pricing.css";

function Pricing() {
  return (
    <div>
      <>
        <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width,initial-scale=1" />

          <base href="/" />
          <meta
            name="description"
            content="Get upfront pricing for JunkDroid’s junk removal services. No hidden fees—see average costs for furniture, appliance hauling, and more. Request a free estimate!"
          />
          <link
            rel="preload"
            as="image"
            href="/assets/img/truck-img.webp"
            type="image/webp"
          />
          <link rel="canonical" href="https://junkdroid.com/pricing/" />
          <link rel="icon" href="assets/img/favicon.png" />
          <title>
            Junk Droid Pricing & Costs | Transparent Junk Removal Rates
          </title>
        </head>

        <HeaderCities />
        {/* ============= Pricing Works Junk Removal Section Start Here ==================== */}
        <div className="container-fluid pricing-removal-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="removal-sec remove-head-sec price-head">
                  <h1>
                    How Our Junk Removal <span>Pricing Works</span>
                  </h1>
                  <div className="sliderline-svg removal-svg price-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={64}
                      height={4}
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                        fill="#60BDFF"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-md-5 btn-section">
                <a href="https://online-booking.workiz.com/?ac=2f3063010df7315df866536f0fa1a1f46be816ae2841d0100103eb5b69cf328f">
                  <button type="button" className="btn removal-btn">
                    Book Appointment&nbsp;
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* ============= Pricing Works Junk Removal Section End Here ==================== */}
        {/* ============= Pricing Junk Removal Section Start Here ==================== */}
        <div className="container faq-sec pricing-junk-sec">
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <h2 className="mb-0">
                How Our Junk Removal <span>Pricing Works</span>
              </h2>
              <div className="sliderline-svg pricing-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <img
                src="/assets/img/truck-img.webp"
                alt="Delivery Truck"
                className="pricing-img-mobile"
                loading="eager"
                decoding="async"
              />

              <p>
                You control the price—it’s based on how much space your junk
                takes up in the truck. It starts from our minimum charge all the
                way up to a full truckload.
              </p>
              <h3>Our trucks each hold the equivalent of:</h3>
              <div class="sliderline-svg pricing-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="4"
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  ></path>
                </svg>
              </div>
              <ul className="pricing-list">
                <li>Five pickup trucks worth of junk</li>
                <li>5 full-sized three-seater sofas</li>
                <li>Or, roughly 2 tons of junk</li>
              </ul>
              <h3>Your Price Includes Everything</h3>
              <div class="sliderline-svg pricing-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="4"
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  ></path>
                </svg>
              </div>
              <ul>
                <li>Loading and clean-up - all you have to do is point!</li>
                <li>Frendly team who are fully licensed and insured.</li>
                <li>All disposal and environmental fees.</li>
              </ul>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="pricing-removal">
                <img
                  src="/assets/img/truck-img.webp"
                  alt="Delivery Truck"
                  className="pricing-img-desk"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
        {/* ============= Pricing Junk Removal Section End Here ==================== */}

        {/* ================== FAQ's Section Start HERE =========================  */}
        <div className="container faq-sec">
          <div className="row removal-faq-sec">
            <div className="col-md-12">
              <div>
                <h2 className="pricing-faq pb-3 mb-0">
                  Frequently <span>Asked Questions</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              {/* =========== FAQ ============== */}
              <FAQsPricing />
              {/* ======== FAQ */}
            </div>
          </div>
        </div>
        {/* ================== FAQ's Section End HERE =========================  */}
      </>
    </div>
  );
}

export default Pricing;
